import { Box, Grid, Typography } from "@mui/material";

import { PlayoffForm } from "../../components/Playoff/PlayoffForm";
import { PlayoffProvider } from "../../context/PlayoffContext";

export const AddPlayoff = () => {
  return (
    <>
      <PlayoffProvider cart={false}>
        <Grid container justifyContent="center" spacing={2} mt={5}>
          <Grid item xs={12} md={8}>
            <Box display="flex" justifyContent="space-between" sx={{ p: 2 }}>
              <Typography variant="h6" gutterBottom>
                Add Playoff
              </Typography>
            </Box>
          </Grid>

          <PlayoffForm />
        </Grid>
      </PlayoffProvider>
    </>
  );
};
